export default defineNuxtRouteMiddleware(async (to) => {
    const { $wadAcl } = useNuxtApp();
    return await $wadAcl.requireDeveloper(to);
})
